var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-plans"},_vm._l((_vm.filteredPlans),function(plan){return _c('billing-plans-item',{key:plan.id,attrs:{"plan-data":plan},on:{"plan-selected":_vm.planSelectedHandler}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }